export default __webpack_public_path__ + "static/filethumb-2e190189bec2ca5f5f0be99e7c4f8c5b.png";